import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M33.5928 35.6172L0 35.6172L0 8.54395L33.5928 8.54395L33.5928 0L56 22.0811L33.5928 44V35.6172ZM44.582 22.0605L38.9844 16.5439L8 16.5439V27.6172L38.9004 27.6172L44.582 22.0605Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 44

/**
 * Arrow Right cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */

export const ArrowRightCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default ArrowRightCutoutShape
